import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from './axios-instance';

/**
 * Custom fetcher that bridges Orval's generated code to our Axios instance.
 * Orval calls this instead of fetch/axios directly.
 */
export const customFetch = async <T>(config: {
  url: string;
  method: string;
  params?: Record<string, unknown>;
  data?: unknown;
  headers?: Record<string, string>;
  signal?: AbortSignal;
  responseType?: string;
}): Promise<T> => {
  const requestConfig: AxiosRequestConfig = {
    url: config.url,
    method: config.method,
    params: config.params,
    data: config.data,
    headers: config.headers,
    signal: config.signal,
    responseType: config.responseType as AxiosRequestConfig['responseType'],
  };

  const response = await axiosInstance.request<T>(requestConfig);
  return response.data;
};

export default customFetch;
